export enum ScreenType {
  EMAIL_ENTRY = "EMAIL_ENTRY",
  OTP_VERIFICATION = "OTP_VERIFICATION",
  SETUP_ACCOUNT = "SETUP_ACCOUNT",
}

export interface NavigationState {
  currentScreen: ScreenType;
  email: string;
  otpCode: string;
  hasError: boolean;
  errorText?: string;
}
